"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var react_1 = __importStar(require("react"));
var contexts_1 = require("../../contexts");
var CrudCreate = function (props) {
    var onCreate = props.onCreate, children = props.children;
    var crudState = react_1.useMemo(function () { return ({
        selectedItem: undefined,
        isCreate: true,
        isUpdate: false,
    }); }, []);
    var childrenWithProps = react_1.useMemo(function () {
        return react_1.default.Children.map(children, function (child) {
            return react_1.default.cloneElement(child, {
                initialValues: undefined,
                onSubmit: onCreate,
            });
        });
    }, [children, onCreate]);
    return (react_1.default.createElement(contexts_1.CrudContext.Provider, { value: crudState },
        react_1.default.createElement(antd_1.Card, { className: "ant-app-details-area" }, childrenWithProps)));
};
exports.default = CrudCreate;
